"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;exports.__esModule = true;exports.LightTheme5_4 = void 0;var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));var _ThemeHelpers = require("../../lib/theming/ThemeHelpers");

var _BasicTheme = require("./BasicTheme");
var _LightTheme5_2 = require("./LightTheme5_3");
var _consts = require("./consts");var _LightTheme5_;

var LightTheme5_4 = exports.LightTheme5_4 = (0, _ThemeHelpers.createTheme)({
  themeClass: (_LightTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {function LightTheme5_4() {return _BasicThemeClassForEx.apply(this, arguments) || this;}(0, _inheritsLoose2.default)(LightTheme5_4, _BasicThemeClassForEx);return LightTheme5_4;}(_BasicTheme.BasicThemeClassForExtension), _LightTheme5_.
  textareaMargin = _consts.themeTokens5_4.textareaMargin, _LightTheme5_.
  clearCrossIconWidthSmall = _consts.themeTokens5_4.clearCrossIconWidthSmall, _LightTheme5_.
  clearCrossIconWidthMedium = _consts.themeTokens5_4.clearCrossIconWidthMedium, _LightTheme5_.
  clearCrossIconWidthLarge = _consts.themeTokens5_4.clearCrossIconWidthLarge, _LightTheme5_.
  clearCrossIconAlign = _consts.themeTokens5_4.clearCrossIconAlign, _LightTheme5_.
  textareaVerticalAlign = _consts.themeTokens5_4.textareaVerticalAlign, _LightTheme5_),

  prototypeTheme: _LightTheme5_2.LightTheme5_3,
  themeMarkers: [(0, _ThemeHelpers.markThemeVersion)('5.4')]
});